import { Component, inject } from '@angular/core';
import { ClosetDoorsStandardService } from 'src/app/services/configurators-2d/applications/closet-doors-standard.service';
import { CurrentService } from 'src/app/services/current.service';

/**
 * Preview de l'étape Récapitulatif.
 * Affiche les vantaux dans leur état final en lecture seule, sans interaction possible.
 * Le rendu multi-sections (couleurs + profilé) est identique à celui de l'étape Finitions.
 */
@Component({
  selector: 'ng-casto-closet-doors-standard-preview-summary',
  templateUrl: './preview-step-summary.component.html',
  styleUrls: ['./preview-step-summary.component.scss'],
})
export class PreviewStepSummaryComponent {
  private readonly current = inject(CurrentService);
  private readonly closetDoorsService = inject(ClosetDoorsStandardService);

  /** Préfixe d'URL pour les images servies par l'API. */
  protected readonly baseImgURL = this.closetDoorsService.apiUrl;

  /** Liste des vantaux configurés dans leur état final. */
  protected get doors() {
    return this.current.closetDoors.doors;
  }

  /** Retourne l'URL de background d'une section pour l'affichage CSS. */
  protected getSectionBackground(section: any): string | null {
    const color = section.color;
    if (!color?.icon) return null;
    return `url(${this.baseImgURL}${color.icon})`;
  }

  /** Indique si le vantail est en premier plan (recouvrement coulissant). */
  protected isInFront(id: number): boolean {
    const panel = this.getCurrentPanel(id);
    return panel !== null ? panel.orderFromFront === 1 : false;
  }

  /** Indique si le vantail a un décalage horizontal de recouvrement. */
  protected isOffset(id: number): boolean {
    const panel = this.getCurrentPanel(id);
    return panel !== null ? panel.isOffset : false;
  }

  /** Retourne la valeur CSS `margin-left` pour le recouvrement coulissant. */
  protected calculateOffset(id: number): string {
    const door = this.doors.find((d: any) => d.id === id);
    if (!door?.layer?.percentOffsetIfOverlay || !this.current.closetDoors.doorNumber) return '0';
    return `calc(-${door.layer.percentOffsetIfOverlay / this.current.closetDoors.doorNumber}%)`;
  }

  private getCurrentPanel(id: number): any {
    const allPanels = this.closetDoorsService.panelGroups.flatMap(g => g.panels);
    const panel = allPanels.find(p => p.panelCount === this.current.closetDoors.doorNumber);
    return panel?.panels?.find(p => p.index === id) ?? null;
  }
}
